import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: [],
  },
  action
) {
  switch (action.type) {
    case homeConstants.RECENT_SEARCH_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.RECENT_SEARCH_SUCCESS: {
      let result = [];
      if (action.response && action.response.data) {
        result = action.response.data.map((item) => {
          return {
            ...item,
            productId: item.id,
          };
        });
      }
      sessionStorage.setItem("recentSearch", JSON.stringify(result));
      return {
        ...state,
        data: result,
        isProgress: false,
      };
    }
    case homeConstants.RECENT_SEARCH_ERROR:
      return {
        ...state,
        error: action.error,
        data: [],
        isProgress: false,
      };
    default:
      return state;
  }
}
